// This function allow to reference async chunks and sibling chunks for the entrypoint
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"630":"16d7a7c29f8a21016a64","3169":"fc6e89cd6d4cabfd0ce3","3520":"30f6ae9f0a59430fb8c4"}[chunkId] + ".js";
};